export * from './auth';
export * from './client';
export * from './dashboard';
export * from './applications';
export * from './projects';
export * from './scans';
export * from './profile';
export * from './personalAccessToken';
export * from './apiKeys';
export * from './billing';
export * from './components';
export * from './policies';
export * from './notifications';
export * from './package-limits';
export * from './licenses';

import { authAPI } from './auth';
import { ProfileAPI } from './profile';
import { PersonalAccessTokenAPI } from './personalAccessToken';
import { ApplicationAPI } from './applications';
import { ProjectAPI } from './projects';
import { ScanAPI } from './scans';
import { DashboardAPI } from './dashboard';
import { BillingAPI } from './billing';
import { ComponentsAPI } from './components';
import {TeamAPI} from './team'
import { PolicyAPI } from './policies';
import { NotificationAPI } from './notifications';
import { PackageLimitsAPI } from './package-limits';
import { LicenseAPI } from './licenses';

export const api = {
    auth: authAPI,
    profiles: ProfileAPI,
    applications: ApplicationAPI,
    projects: ProjectAPI,
    scans: ScanAPI,
    dashboard: DashboardAPI,
    billing: BillingAPI,
    components: ComponentsAPI,
    teams: TeamAPI,
    policies: PolicyAPI,
    notifications: NotificationAPI,
    packageLimits: PackageLimitsAPI,
    personalAccessTokens: PersonalAccessTokenAPI,
    licenses: LicenseAPI
};

export { authAPI as AuthAPI, ProfileAPI, ApplicationAPI, ProjectAPI, ScanAPI, DashboardAPI, BillingAPI, TeamAPI, ComponentsAPI, PolicyAPI, NotificationAPI, PackageLimitsAPI, PersonalAccessTokenAPI, LicenseAPI };